import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.72 4.28L8.6.28A1 1 0 0 0 7.18.3a1 1 0 0 0 0 1.42L9.56 4H1a1 1 0 0 0 0 2h8.56L7.2 8.28a1 1 0 0 0 1.4 1.44l4.12-4a1 1 0 0 0 0-1.44z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 13 10"
  }, props), _ref);
};

export default SvgComponent;